import { PropsWithChildren, useEffect, useReducer } from 'react';

import { useAppContext } from 'business/contextProviders/useAppContext';

import { useMode } from './../use-mode';
import { getGraphSetContext, GraphSetUpdateContext } from './contexts';
import { getInitialGraphSetState } from './get-initial-graph-set';
import { createGraphSetReducer } from './reducer';
import { GraphSetDispatchActions } from './types';

export const GraphSetProvider = ({ children }: PropsWithChildren) => {
  const mode = useMode();
  const { currentConstructionSiteId } = useAppContext();

  const graphSetContext = getGraphSetContext(mode);

  const graphSetReducer = createGraphSetReducer();
  const [graphSet, dispatchGraphSet] = useReducer(
    graphSetReducer,
    getInitialGraphSetState(mode),
  );

  useEffect(() => {
    dispatchGraphSet({
      type: GraphSetDispatchActions.ResetGraphSet,
      mode,
    });
  }, [mode, currentConstructionSiteId]);

  return (
    <graphSetContext.Provider value={graphSet}>
      <GraphSetUpdateContext.Provider value={dispatchGraphSet}>
        {children}
      </GraphSetUpdateContext.Provider>
    </graphSetContext.Provider>
  );
};
